module.exports = __webpack_public_path__ + "img/compare-energy.147ff00.webp";